import { useIntl } from "react-intl";
import * as yup from "yup";
import messages from "./messages.i18n";
import { PeekInput } from "@piiqtechnologies/ui-components";
import { PROVIDERS, ProvidersSelector } from "./utils";
import { AiDiscoverabilityAddressInput } from "./AiDiscoverabilityAddressInput";
export const AiDiscoverabilityFormInitialValues = {
    subjectName: "",
    subjectAddress: null,
    llmProviders: PROVIDERS.map((provider) => {
        var _a, _b;
        return ({
            provider: provider.id,
            model: (_b = (_a = provider.models[0]) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : "",
        });
    }).filter((item) => Boolean(item.model)),
};
export const AiDiscoverabilityFormValidationSchema = () => {
    const intl = useIntl();
    const getAddressValue = (value) => {
        if (!value)
            return "";
        if (typeof value === "string")
            return value;
        return value.name || value.description || "";
    };
    return yup.object().test(function (values) {
        var _a;
        const { subjectName, subjectAddress } = values;
        if (!(subjectName === null || subjectName === void 0 ? void 0 : subjectName.trim()) && !((_a = getAddressValue(subjectAddress)) === null || _a === void 0 ? void 0 : _a.trim())) {
            return this.createError({
                path: "subjectName",
                message: intl.formatMessage(messages.aiDiscoverabilityValidationAtLeastOneField),
            });
        }
        return true;
    });
};
export const getAiDiscoverabilityFormFields = (mapAPiloaded) => {
    const intl = useIntl();
    return {
        prospect: [
            {
                id: "receiverEmail",
                label: intl.formatMessage(messages.aiDiscoverabilityReceieverEmailLabel),
                placeholder: intl.formatMessage(messages.aiDiscoverabilityReceieverEmailPlaceholder),
                required: false,
                columns: 12,
                fullWidth: true,
                component: PeekInput,
            },
        ],
        community: [
            {
                id: "subjectName",
                label: intl.formatMessage(messages.aiDiscoverabilitysubjectNameLabel),
                placeholder: intl.formatMessage(messages.aiDiscoverabilitysubjectNamePlaceholder),
                required: true,
                columns: 12,
                fullWidth: true,
                component: PeekInput,
            },
            {
                id: "subjectAddress",
                label: intl.formatMessage(messages.aiDiscoverabilitysubjectAddressLabel),
                placeholder: intl.formatMessage(messages.aiDiscoverabilitysubjectAddressPlaceholder),
                required: true,
                columns: 12,
                fullWidth: true,
                component: AiDiscoverabilityAddressInput,
                mapAPiloaded,
            },
        ],
        llmProviders: [
            {
                id: "llmProviders",
                label: intl.formatMessage(messages.aiDiscoverabilityAgentModelLabel),
                placeholder: "",
                required: false,
                columns: 12,
                fullWidth: true,
                component: ProvidersSelector,
            },
        ],
    };
};
